/**
 * @file useData.js
 * Hook di accesso al DataContext.
 * Fornisce risorse, pianificazioni e altri dati centralizzati dell'applicazione.
 */

import { useContext } from 'react';
import { DataContext } from '../context/DataContext';

/**
 * Hook che espone il DataContext contenente i dati applicativi (risorse, calendario, ecc.).
 * Lancia un errore se usato al di fuori del DataProvider.
 * @returns {object} Il valore del contesto DataContext
 */
export function useData() {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error('useData must be inside DataProvider');
  return ctx;
}
